import { Box, Typography, Grid, Card, CardContent, Stack } from '@mui/material';
import {
  Email as EmailIcon,
  People as PeopleIcon,
  LocalHospital as LocalHospitalIcon,
} from '@mui/icons-material';

interface UserManagementHeaderProps {
  organizationName: string;
  patientCount: number;
  providerCount: number;
  pendingInvitesCount: number;
}

export const UserManagementHeader = ({
  organizationName,
  patientCount,
  providerCount,
  pendingInvitesCount,
}: UserManagementHeaderProps) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h4" gutterBottom>
      User Management
    </Typography>
    <Typography color="text.secondary" gutterBottom>
      Manage users, send invitations, and assign care teams for {organizationName}
    </Typography>

    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item xs={12} sm={4}>
        <Card>
          <CardContent>
            <Stack direction="row" alignItems="center" spacing={2}>
              <PeopleIcon color="primary" sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h4">{patientCount}</Typography>
                <Typography color="text.secondary" variant="body2">
                  Active Patients
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Card>
          <CardContent>
            <Stack direction="row" alignItems="center" spacing={2}>
              <LocalHospitalIcon color="success" sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h4">{providerCount}</Typography>
                <Typography color="text.secondary" variant="body2">
                  Care Providers
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Card>
          <CardContent>
            <Stack direction="row" alignItems="center" spacing={2}>
              <EmailIcon color="warning" sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h4">{pendingInvitesCount}</Typography>
                <Typography color="text.secondary" variant="body2">
                  Pending Invites
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  </Box>
);
